module.exports = __webpack_public_path__ + "static/media/logo2.0ae3f1ee.png";